export const colorPalette = {
    white: '#FFFFFF',
    gray100: '#F7F7F7',
    gray200: '#EBEBEB',
    gray300: '#D1D1D1',
    gray400: '#B6B6B6',
    gray500: '#9C9C9C',
    gray600: '#828282',
    gray700: '#686868',
    gray800: '#4D4D4D',
    gray900: '#333333',
    gray1000: '#000000',
    red100: '#FFF0F0',
    red200: '#FFD3D3',
    red300: '#FB9A9A',
    red400: '#F76B6B',
    red500: '#F53A3A',
    red600: '#EC0606',
    red700: '#D80000',
    red800: '#BF0000',
    red900: '#8C0000',
    red1000: '#590000',
    orange100: '#FEF3EB',
    orange200: '#FFDBA3',
    orange300: '#FFC870',
    orange400: '#FFB238',
    orange500: '#F59600',
    orange600: '#DB8600',
    orange700: '#B87100',
    orange800: '#995E00',
    orange900: '#7B4B00',
    orange1000: '#5C3800',
    yellow100: '#FFF5CC',
    yellow200: '#FFEB99',
    yellow300: '#FFE066',
    yellow400: '#FFD633',
    yellow500: '#FFCC00',
    yellow600: '#DBAF00',
    yellow700: '#B89300',
    yellow800: '#947600',
    yellow900: '#705A00',
    yellow1000: '#4D3D00',
    green100: '#EBF7EC',
    green200: '#BFF4BF',
    green300: '#8DE98D',
    green400: '#5FD95F',
    green500: '#2AC72A',
    green600: '#00B900',
    green700: '#009500',
    green800: '#006C00',
    green900: '#005300',
    green1000: '#003900',
    lightBlue100: '#EBF7FE',
    lightBlue200: '#AEE4FF',
    lightBlue300: '#7BD3FF',
    lightBlue400: '#4DC4FF',
    lightBlue500: '#1FB4FF',
    lightBlue600: '#00A0F0',
    lightBlue700: '#0085C7',
    lightBlue800: '#006A9E',
    lightBlue900: '#004E76',
    lightBlue1000: '#00334D',
    blue100: '#E8EEFF',
    blue200: '#C9D7FF',
    blue300: '#A0B9FF',
    blue400: '#82A3FF',
    blue500: '#6C92FB',
    blue600: '#3A6DFA',
    blue700: '#134FF3',
    blue800: '#053ACE',
    blue900: '#002896',
    blue1000: '#001D6D',
    purple100: '#F7E7FF',
    purple200: '#F1D7FF',
    purple300: '#E7B9FF',
    purple400: '#D78BFF',
    purple500: '#C962FF',
    purple600: '#B62AFF',
    purple700: '#9B00EC',
    purple800: '#7D00BE',
    purple900: '#65009A',
    purple1000: '#4B0071',
    pink100: '#FFE9F8',
    pink200: '#FFDAF2',
    pink300: '#FFACE3',
    pink400: '#FF79D1',
    pink500: '#FF41BE',
    pink600: '#EF0AA1',
    pink700: '#CB0085',
    pink800: '#A2006A',
    pink900: '#830056',
    pink1000: '#5A003C',
    couponApp: '#3DBD7D',
    transparent: 'transparent',
};
